import { render, staticRenderFns } from "./tabExternalProjectIntention.vue?vue&type=template&id=ebfb5428&scoped=true&"
import script from "./tabExternalProjectIntention.vue?vue&type=script&lang=ts&"
export * from "./tabExternalProjectIntention.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ebfb5428",
  null
  
)

export default component.exports